import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-auto-download",
  "use": "app-icon-auto-download-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-auto-download\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#FFF\" d=\"M0 0h16v16H0z\" /><path d=\"M8 0c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm0 1.5C4.42 1.5 1.5 4.42 1.5 8s2.92 6.5 6.5 6.5 6.5-2.92 6.5-6.5S11.58 1.5 8 1.5zM7.64 4c.2-.2.51-.2.71 0L11 6.65H8.75v4.75c0 .41-.34.75-.75.75s-.75-.34-.75-.75V6.65H5z\" fill=\"#6C92FA\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol